// extracted by mini-css-extract-plugin
export var actions = "_20-0";
export var actionsContainer = "_20-7";
export var border = "_20-1";
export var childFullHeight = "_20-f";
export var collapse = "_20-2";
export var content = "_20-a";
export var contentChild = "_20-e";
export var fullscreen = "_20-c";
export var hasLeftRadius = "_20-k";
export var headerContainer = "_20-3";
export var headerRow = "_20-5";
export var hidePadding = "_20-b";
export var navCollapsedGap = "_20-l";
export var noScrollX = "_20-m";
export var noScrollY = "_20-n";
export var noTopPadding = "_20-i";
export var optOutTopPadding = "_20-d";
export var pageMain = "_20-j";
export var pageOuter = "_20-g";
export var pagePadding = "_20-8";
export var pageScroll = "_20-9";
export var profile = "_20-o";
export var profileContainer = "_20-p";
export var profileImage = "_20-q";
export var profileMain = "_20-r";
export var profileSubtitle = "_20-t";
export var profileTitle = "_20-s";
export var showLeftPadding = "_20-h";
export var tabsPortalSlot = "_20-6";
export var tabsWrapper = "_20-4";
export var title = "_20-u";